import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').factory('Registration', registrationService);

    /**
     * @param $resource
     * @param API_URL
     * @returns {Object} $resource
     * @author flzemke.btc
     * @ngInject
     */
    function registrationService($resource, API_URL) {
        return $resource(
            API_URL.REGISTRATION,
            {},
            {
                start: {
                    method: 'GET',
                    url: API_URL.REGISTRATION + 'start/:eic',
                    params: {
                        eic: '@eic'
                    }
                },
                register: {
                    method: 'POST',
                    url: API_URL.REGISTRATION + 'register'
                },
                getUserAsPdf: {
                    method: 'POST',
                    url: API_URL.REGISTRATION + 'user/pdf/prepare'
                },
                isDvgwValid: {
                    method: 'GET',
                    url: API_URL.REGISTRATION + 'dvgw-data/:dvgwCode',
                    interceptor: {
                        response: function (res) {
                            return res.data;
                        }
                    }
                }
            }
        );
    }
})();
